import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CommunicationPanel.html?raw';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import PageStack from '../../../moreCore/UI/Tabbing/PageStack';
import CommunicationObjectList from '../../CommunicationObject/CommunicationObjectList';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { EntityHelpers } from "../../../more/Helpers";

class CommunicationPanel extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private mode: "person" | "company";
    private contextAddressId: string = null;
    private pageStack: MdsLax<InstanceType<typeof PageStack>>;
    private personCommList: MdsLax<InstanceType<typeof CommunicationObjectList>>;
    private companyCommList: MdsLax<InstanceType<typeof CommunicationObjectList>>;
    private membersTable: MdsLax<InstanceType<typeof StaticTable>>;

    private emailTableLayout;
    private hasContent: boolean = false;

    constructor(mode: "person" | "company", contextAddressId: string = null) {
        super(...(arguments as unknown as []));
        this.mode = mode;
        this.contextAddressId = contextAddressId;
    }

    private loadBaseCommList(mode: "person" | "company") {
        let commList: MdsLax<InstanceType<typeof CommunicationObjectList>>;
        switch (mode) {
            case "person":
                commList = this.personCommList;
                break;
            case "company":
                commList = this.companyCommList;
                break;
            default:
                return;
        }

        commList = new CommunicationObjectList("addressWizard", this.contextAddressId);
        commList.placeAt(this.pageStack.getPageByName(mode).contentNode);
        commList.on("hasContent", (obj: { hasContent: boolean }) => {

            if (this.hasContent == false) {
                this.hasContent = obj.hasContent;
                this.emit("hasContent", { hasContent: this.hasContent });
            }
        })
    }

    private loadCompanyMemberEmails() {

        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API_CommunicationPanel__GetCompanyMemberEmailList",
            {
                addressId: this.contextAddressId
            },
            lang.hitch(this, this._onLoadMemberEmailsResponse),
            lang.hitch(this, this._showErrorMessage)
        )
    }
    private tableExpanderSetup(rowgroup: StaticTable.StaticTableRowGroup<any>): HTMLElement {

        let main = this.UiModder.domConstruct.create("div");

        if (rowgroup.entity.emails?.length > 0) {
            let div = this.UiModder.domConstruct.create("div", { class: "flex_row_center right gap_1 paddingSmall-Y" }, main);
            let btn = this.UiModder.domConstruct.create("button", { class: "mds-button-base accentBG hoverBright round" }, div);
            this.createFontawesomeIcon("fas fa-list", "&nbsp;", btn);
            this.UiModder.domConstruct.create("span", { innerHTML: this.translate("CommunicationPanel_Btn_ShowAll") }, btn);

            on(btn, "click", lang.hitch(this, this._onClick_ShowAllBtn, rowgroup.entity.ID, rowgroup.entity.$Displayname))

            let table = new StaticTable();
            table.setLayout(this.emailTableLayout);
            table.setData(rowgroup.entity.emails);
            table.setRowClick(lang.hitch(this, this.onEmailTableRowClick));

            table.placeAt(main);
            table.setCyAttribute("communicationPanel");
        } else {

            this.UiModder.domConstruct.create("p", { class: "flex_row_center italic w3-text-gray justify_center", innerHTML: this.translate("General__NoEntries") }, main);
            this.UiModder.domClass.add(main, "w3-opacity");
            rowgroup.rows.forEach(r => {
                this.UiModder.domClass.add(r.node, "w3-opacity");
            });
        }

        return main;
    }

    private _onClick_ShowAllBtn(id: string, displayname: string) {

        let dlg = new CommunicationObjectList("addressWizard", id);
        dlg.show("dlg", displayname);
    }

    private onEmailTableRowClick(row: StaticTable.StaticTableRow<any>, rowGroup: StaticTable.StaticTableRowGroup<any>, evt: Event) {

        this.StandbyStart();

        EntityHelpers.openEntityView({
            entityClass: "email_transmission",
            entityId: rowGroup.entity.ID,
            label: null,
            contextName: `CommunicationObjectList_addressWizard`,
        });

        this.StandbyStop();
    }

    private _onLoadMemberEmailsResponse(response) {

        switch (response.contextAddressClassName) {
            case "organisations_external":
                this.pageStack.setPageLabel("members", this.translate("AddressWizard__ContactPerson"));
                break;
            case "organisations_internal":
                this.pageStack.setPageLabel("members", this.translate("General_Label_Associates"));
                break;
        }

        this.emailTableLayout = response.emailTableLayouts[0];
        let membersTableLayout = response.membersTableLayouts[0];

        this.membersTable.setLayout(membersTableLayout);
        this.membersTable.setupExpandableRows({
            expanderContentCallback: lang.hitch(this, this.tableExpanderSetup),
            expanderClickCallback: () => { }
        })

        this.membersTable.setData(response.memberList);

        if (this.hasContent == false) {
            this.hasContent = response.memberList.length > 0;
            this.emit("hasContent", { hasContent: this.hasContent });
        }
        this.StandbyStop();
    }

    private _showErrorMessage(err?: more.requestErrorMessage | string) {
        let msg;

        if (typeof err == "string") msg = err;
        else msg = err ? err.Message : "...error occured";

        this.showToast(msg, "fas fa-exclamation-triangle");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        switch (this.mode) {
            case "person":
                this.pageStack.showPage("person", true);
                this.pageStack.hidePage("company");
                this.pageStack.hidePage("members");

                this.loadBaseCommList(this.mode);
                break;
            case "company":
                this.pageStack.showPage("company", true);
                this.pageStack.hidePage("person");

                this.loadBaseCommList(this.mode);
                this.loadCompanyMemberEmails();
                break;
        }
        this.pageStack.showPage(this.mode, true);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(CommunicationPanel);